import { useState, useContext } from "react";
import CheckUpContext from "../../context/check-up";
import Icon from "../icon";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import localeData from "dayjs/plugin/localeData";
import "dayjs/locale/it";
import "dayjs/locale/fr";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import CheckUpDiscardRequestModal from "./check-up-discard-request-modal";
import CheckUpBoxWrapper from "./check-up-box-wrapper";
import UserContext from "../../context/user";
import { useQueryClient } from "@tanstack/react-query";
import CheckUpSubmitRequestModal from "./check-up-submit-request-modal";
dayjs.extend(LocalizedFormat);
dayjs.extend(localeData);

const CheckUpStep4 = ({ discardModal, setDiscardModal }) => {
  const { userProfile } = useContext(UserContext);
  const { labels, appLang, currentRequest, setCurrentRequest, setNavigation, handlePrevious } =
    useContext(CheckUpContext);
  const queryClient = useQueryClient();

  const [submitModal, setSubmitModal] = useState(false);

  const handleSaveDraft = () => {
    setCurrentRequest();
    setNavigation();
    queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
  };

  const handleSubmit = () => setSubmitModal(true);

  return (
    <>
      {currentRequest?.status === "DRAFT" && (
        <div
          className="app-content__text"
          dangerouslySetInnerHTML={{
            __html:
              labels?.WELFARE_CHECKUP_CAPTION_RESUME_STEP ||
              "<strong>La tua richiesta è in bozza, controlla la correttezza dei tuoi dati prima di inviarla definitivamente.</strong>",
          }}
        />
      )}
      {["SENT", "IN_PROGRESS", "COMPLETED"].includes(currentRequest?.status) && (
        <div className="app-content__text">
          {currentRequest?.sentDate && (
            <p>
              <strong>
                {labels?.WELFARE_CHECKUP_SENT_DATE || "Data invio"}:{" "}
                {dayjs(Number(currentRequest?.sentDate)).locale(appLang?.value).format("L")}
              </strong>
            </p>
          )}
          {currentRequest?.status !== "SENT" && (
            <>
              {currentRequest?.contactDate && (
                <p>
                  <strong>
                    {labels?.WELFARE_CHECKUP_FIRST_CONTACT_DATE || "Data primo contatto"}:{" "}
                    {dayjs(Number(currentRequest?.contactDate)).locale(appLang?.value).format("L")}
                  </strong>
                </p>
              )}
              {currentRequest?.firstExamDate && (
                <p>
                  <strong>
                    {labels?.WELFARE_CHECKUP_FIRST_VISIT_DATE || "Data prima visita"}:{" "}
                    {dayjs(Number(currentRequest?.firstExamDate))
                      .locale(appLang?.value)
                      .format("L")}
                  </strong>
                </p>
              )}
            </>
          )}
        </div>
      )}
      <CheckUpBoxWrapper
        readOnly={!(currentRequest?.status === "DRAFT" || currentRequest === "new")}
      />
      {(currentRequest?.status === "DRAFT" || currentRequest === "new") && (
        <>
          <div className="form__buttons-wrapper">
            <div className="form__buttons form__buttons--space-between">
              <div className="form__buttons-container">
                <button className="link" type="button" onClick={handlePrevious}>
                  <Icon name="angle-down" />
                  {labels?.WELFARE_FORM_BTN_PREVIOUS || "Previous"}
                </button>
                <button
                  className="button secondary form__submit mobile-only"
                  onClick={handleSaveDraft}
                >
                  {labels?.WELFARE_FORM_BTN_SAVE_DRAFT || "Save draft"}
                </button>
              </div>
              <div className="form__buttons-container">
                <button
                  className="button secondary form__submit desktop-only"
                  onClick={handleSaveDraft}
                >
                  {labels?.WELFARE_FORM_BTN_SAVE_DRAFT || "Save draft"}
                </button>
                <button className="button primary form__submit" onClick={handleSubmit}>
                  {labels?.WELFARE_FORM_BTN_SEND_BOOKING || "Send booking"}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <CheckUpDiscardRequestModal
        key={`discard-${!!discardModal}`}
        discardModal={discardModal}
        setDiscardModal={setDiscardModal}
        skipUpdate={true}
      />
      <CheckUpSubmitRequestModal
        show={submitModal}
        closeModal={() => setSubmitModal(false)}
        key={`submit-${!!submitModal}`}
      />
    </>
  );
};

export default CheckUpStep4;
